var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.524,
    height: 14.269,
    viewBox: "0 0 17.524 14.269",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.588,11.677A2.826,2.826,0,1,1,8.762,8.851,2.829,2.829,0,0,1,11.588,11.677Zm5.936-4.013v8.027a1.938,1.938,0,0,1-1.938,1.938H1.938A1.938,1.938,0,0,1,0,15.691V7.664A1.938,1.938,0,0,1,1.938,5.726H4.321v-.67a1.7,1.7,0,0,1,1.7-1.7h5.491a1.7,1.7,0,0,1,1.7,1.7v.67h2.383A1.939,1.939,0,0,1,17.524,7.664Zm-4.483,4.013a4.279,4.279,0,1,0-4.28,4.28A4.285,4.285,0,0,0,13.042,11.677Z",
    transform: "translate(0 -3.36)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.b165461d314ef27437c61f8db264d8b2.svg";
export { ForwardRef as ReactComponent };